import { Component, OnInit, TemplateRef, Input, inject, Injector } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { ShareMapDialogComponent } from './share-map-dialog/share-map-dialog.component';

import { Subscription } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { TT_LIB_ENV_CONFIG } from '@tt-lib/tt-lib-env.config.token';
import { AppEnvironmentConfig } from '@tt-lib/interfaces/app-environment-config';

@Component({
  selector: 'tt-share-map',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    TranslateModule
  ],
  templateUrl: './share-map.component.html',
  styleUrls: ['./share-map.component.sass'],
  standalone: true
})

export class ShareMapComponent implements OnInit {
  // @ViewChild('template', { static: true }) template: any;
  @Input() showAsListItem: boolean;
  @Input() showAsIcon: boolean;
  @Input() customTemplate: TemplateRef<any>;

  public currentURL: string;
  public encodedCurrentURL: string; // we need this for the 'mailto:...'

  private _appEnvironmentConfig: AppEnvironmentConfig = inject(TT_LIB_ENV_CONFIG); 

  constructor(
    public dialog: MatDialog,
    //private injector: Injector
  ) { 
    //this._appEnvironmentConfig = injector.get(TT_LIB_ENV_CONFIG); 
  }

  ngOnInit() { }

  openDialog(): void {
    this.updateValues(false);
    //'backEventService.registerOpenedWindow' is put in ShareMapDialogComponent (putting it here doesn't work for trace-view with custom template for tag tt-share-map)
    const dialogRef = this.dialog.open(ShareMapDialogComponent, {
      closeOnNavigation: true,
      panelClass: 'share-dialog',
      data: { currentURL: this.currentURL, encodedCurrentURL: this.encodedCurrentURL }
    });

    const sub: Subscription = dialogRef.componentInstance.traceSavedEvt.subscribe((traceParamValue: string) => {
      //x,y,zoom parameters are not really necessary for this type of url, but they can be a fallback in case the route is not available(?)
      //this.updateValues(true);

      this.currentURL += (this.currentURL.indexOf('?') > 0 ? '&' : '?') + 'trace=' + traceParamValue + '&tracezoom=true';
      this.encodedCurrentURL = encodeURIComponent(this.currentURL);

      dialogRef.componentInstance.data.currentURL = this.currentURL;
      dialogRef.componentInstance.data.encodedCurrentURL = this.encodedCurrentURL;
    });

    dialogRef.afterClosed().subscribe(() => {
      sub.unsubscribe();
    });
  }

  /**
   * we only add the necessary parameters to the permalink url (e.g. parameters trace and tracezoom will be skipped here)
   * 
   * @param removeXYZ if true, parameters x&y&zoom will not be added to the permalink url
   */
  updateValues(removeXYZ: boolean) {
    let skippedParameters = ['trace', 'tracezoom'];
    skippedParameters = removeXYZ ? skippedParameters.concat(['x', 'y', 'zoom']) : skippedParameters;

    let currentParamsString = '';
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach((value: string, key: string, parent: URLSearchParams) => {
      if (!skippedParameters.includes(key)) {
        currentParamsString += (currentParamsString.length > 0 ? '&' : '') + key + (value ? '=' + value : '');
      }
    });

    //(window.location.protocol === 'capacitor:' ? 'https://' : '')
    this.currentURL = (this._appEnvironmentConfig.BASEURL && this._appEnvironmentConfig.BASEURL.indexOf('http') === 0 ? this._appEnvironmentConfig.BASEURL : (window.location.hostname === 'localhost' ? 'https://topomapviewer.ngi.be' : (window.location.protocol + '//' + window.location.hostname))) +
      (window.location.port.length > 0 && window.location.port !== '80' ? ':' + window.location.port : '') +
      (currentParamsString.length > 0 ? '?' + currentParamsString : '');
    this.encodedCurrentURL = encodeURIComponent(this.currentURL);
  }

}